/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The reason for the inspection
 */
export enum ReasonForInspection {
	NEW_METER = 'New Meter',
	REVALIDATION = 'Revalidation',
	REPLACEMENT = 'Replacement',
}
